import React, { useState } from "react";
import { Tag, DatePicker, Select, Checkbox } from "antd";
import dayjs from "dayjs";
import * as R from "ramda";
import "./index.css";

const getTimestamp = value => {
    return value.startOf("day").valueOf();
};

const getWeekdaysOfMonth = selectedMonth => {
    if (!selectedMonth) return [];

    const startOfMonth = selectedMonth.startOf("month");
    const endOfMonth = selectedMonth.endOf("month");
    const weekdaysOfMonth = [];

    for (
        let day = startOfMonth;
        day.isBefore(endOfMonth) || day.isSame(endOfMonth, "day");
        day = day.add(1, "day")
    ) {
        if (day.day() >= 1 && day.day() <= 5) {
            weekdaysOfMonth.push(day);
        }
    }

    return weekdaysOfMonth;
};

const DateCell = ({ currentDate, isSelected }) => (
    <div
        className="ant-picker-cell-inner"
        style={
            isSelected
                ? {
                      position: "relative",
                      zIndex: 2,
                      display: "inlineBlock",
                      width: "24px",
                      height: "22px",
                      lineHeight: "22px",
                      backgroundColor: "#1890ff",
                      color: "#fff",
                      margin: "auto",
                      borderRadius: "2px",
                      transition: "background 0.3s, border 0.3s",
                  }
                : {}
        }
    >
        {currentDate.date()}
    </div>
);

const DateTag = ({ value, onClose, format, selectedDate, onChange }) => {
    const handleClose = () => {
        onClose();
        onChange && onChange(selectedDate.filter(t => t !== value));
    };

    return (
        <Tag onClose={handleClose} closable>
            {dayjs(value).format(format)}
        </Tag>
    );
};

const MultipleDatePicker = ({
    value: selectedDate = [],
    onChange,
    format = "YYYY-MM-DD",
    selectProps = {},
    datePickerProps = {},
    selectedMonth,
}) => {
    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState(false);

    const onValueChange = date => {
        const timestamp = getTimestamp(date);
        const index = selectedDate.indexOf(timestamp);
        const clone = R.clone(selectedDate);

        if (index > -1) {
            clone.splice(index, 1);
        } else {
            clone.push(timestamp);
        }

        onChange && onChange(clone);
    };

    const dateRender = currentDate => {
        const isSelected = selectedDate.indexOf(getTimestamp(currentDate)) > -1;
        return <DateCell currentDate={currentDate} isSelected={isSelected} />;
    };

    const renderTag = ({ value, onClose }) => (
        <DateTag
            value={value}
            onClose={onClose}
            format={format}
            selectedDate={selectedDate}
            onChange={onChange}
        />
    );

    const handleCheckboxChange = () => {
        if (selectedDate.length === 0 && selectedMonth !== null) {
            const weekdaysOfMonth = getWeekdaysOfMonth(selectedMonth);
            const weekdaysTimestamps = weekdaysOfMonth.map(day =>
                getTimestamp(day)
            );

            onChange && onChange(selectedDate.concat(weekdaysTimestamps));
        } else {
            onChange && onChange([]);
        }

        setChecked(!checked);
    };

    return (
        <>
            <Select
                allowClear
                placeholder="Selecteer een datum"
                {...selectProps}
                mode="multiple"
                value={selectedDate}
                onClear={() => onChange && onChange([])}
                tagRender={renderTag}
                open={open}
                onFocus={() => setOpen(true)}
                onBlur={() => setOpen(false)}
                dropdownMatchSelectWidth={false}
                popupClassName="multipleDropdownClassName"
                dropdownStyle={{
                    height: "270px",
                    width: "290px",
                    minWidth: "0",
                }}
                dropdownRender={() => (
                    <DatePicker
                        {...datePickerProps}
                        format={() => ""}
                        onChange={onValueChange}
                        value=""
                        open
                        showToday={false}
                        dateRender={dateRender}
                        style={{
                            ...datePickerProps.style,
                            visibility: "hidden",
                        }}
                        getPopupContainer={() =>
                            document.getElementsByClassName(
                                "multipleDropdownClassName"
                            )[0]
                        }
                    />
                )}
            />

            <Checkbox
                style={{ marginTop: 10 }}
                checked={checked}
                onChange={handleCheckboxChange}
            >
                Alle werkdagen van de opgegeven declaratie maand
            </Checkbox>
        </>
    );
};

export default MultipleDatePicker;
